import axios from "../../axiosInstance";
import type { ItemAssignmentRequest } from "@/modules/learningCenter/features/BadgeManagement/types/badge.types";

interface AssignmentResponse {
  success: boolean;
  itemId: string;
}

export const assignBadgeToItem = async (data: ItemAssignmentRequest): Promise<AssignmentResponse> => {
  const response = await axios.post<AssignmentResponse>(
    `/api/badges/${data.badgeId}/assign-to-item`,
    { path_item_id: data.pathItemId }
  );
  return response.data;
};

export default assignBadgeToItem;
